module.exports = __webpack_public_path__ + "assets/img/icon2.b44e8b77.png";